<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-余额管理-余额设置
  -->
  <div class="pb50">
    <el-form ref="form" size="small" :model="form" label-width="200px">
   
      <div class="common-form">{{getAppinfo('balance_text')}}转换佣金</div>
      <el-form-item :label="'是否开启'+getAppinfo('balance_text')+'转换为佣金'">
        <el-radio-group v-model="form.is_wopen">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
      </el-form-item>
      <el-form-item label="佣金到账比例" v-if="form.is_wopen == 1">
        <el-input placeholder="请输入到账比例" v-model="form.succ_ratio" class="max-w460">
        </el-input><span>%</span>
        <div>到账{{getAppinfo('welfare_text')}}比例：{{  getPrice(100*(1-form.succ_ratio/100)) }}%，注：{{getAppinfo('welfare_text')}}购买不产生奖励</div>
      </el-form-item>
      <el-form-item :label="'最低转换'+getAppinfo('balance_text')" v-if="form.is_wopen == 1">
        <el-input placeholder="请输入内容" v-model="form.less_withdraw" class="max-w460">
          
        </el-input>
        <div class="lh18 mt10 gray9">
          <p>注：佣金可提现</p>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>

    </el-form>
  </div>
</template>
<script>
  import BalanceaApi from '@/api/balancea.js';
  export default {
    data() {
      return {
        form: {
          is_wopen:0,
       
        },
        loading: false,
      };
    },
    created() {
      /*获取数据*/
      this.getData();
    },
    methods: {
      roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        console.log("price",this.roundToDecimalPlace(price,2))
        return this.roundToDecimalPlace(price,0)
      },
      /*获取数据*/
      getData() {
        let self = this;
        let Params = {};
        BalanceaApi.getBalance(Params, true).then(data => {
          self.form = data.data.values;
        }).catch(error => {

        });
      },

      /*保存*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            BalanceaApi.setBalance(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，保存成功',
                    type: 'success'
                  });
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });

          }
        });


      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/balance/part/Setting.vue